import pm from "./pm";
import npg from "./npg";
import utils from "./utils";

export default {
  pm: { ...pm },
  npg: { ...npg },
  utils
};
